import { useEffect, useState } from 'react';
import PageTemplate from 'components/template/PageTemplate';
import Container from 'components/common/Container';
import { useAtom } from 'jotai';
import { containerFileAtom, quoteFileAtom, quoteInfoAtom } from 'atom/quote';
import First from 'components/quote/simple/confirm/First';
import Second from 'components/quote/simple/confirm/Second';
import CustomButton from 'components/common/CustomButton';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import usePreventRefresh from 'hook/usePreventRefresh';
import { formAxios, jsonAxios } from 'components/axios';
import QuoteDoneDialog from 'components/common/QuoteDoneDialog';
import { sendTeamRoom } from 'components/nateon';
import { useGetUser } from 'atom/user';
import useCheckCompany from 'hook/useCheckCompany';
import { countryCodeToEmoji, getKoreaDateTime } from 'components/function';

const SimpleConfrim = () => {
    const user = useGetUser();
    const [quoteInfo, setQuoteInfo] = useAtom(quoteInfoAtom)
    const [popOpen, setPopOpen] = useState<boolean>(false);
    const [once, setOnce] = useState<boolean>(false)
    const [containerFile, setContainerFile] = useAtom(containerFileAtom);
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const [fileArr, setFileArr] = useAtom(quoteFileAtom)
    const navigate = useNavigate();

    usePreventRefresh()
    useCheckCompany();

    useEffect(() => {
        if (!quoteInfo?.step1?.tradeType) {
            navigate(-1);
        }
    }, [quoteInfo])

    const goBack = () => {
        navigate(-1)
    }

    const saveQuote = () => {
        setOnce(true)
        const reqData = {
            isShippingDate: quoteInfo.isShippingDate,
            step1: {
                ...quoteInfo.step1,
                shippingDate: quoteInfo.shippingDate
            },
            step2: {
                shipmentMode: quoteInfo.step2.shipmentMode,
                hsCode: quoteInfo.step2.hsCode,
                containerList: quoteInfo.step2.containerList,
                packingList: quoteInfo.step2.packingList
            }
        }

        jsonAxios.post('quote/simple', reqData).then(res => {
            if (res.data.code === 200) {
                const { quoteId: id, containerIds } = res.data.data;
                const formData = new FormData();

                containerIds?.forEach((cid: number, idx: number) => {
                    (containerFile[idx] ?? []).forEach(file => {
                        formData.append(String(cid), file);
                    });
                });

                fileArr?.forEach(file => formData.append('files', file));

                const hasFiles = (containerIds && containerIds.length > 0) || (fileArr?.length > 0);

                if (hasFiles) {
                    setPopOpen(true);
                    formAxios.post(`quote/${id}/file`, formData, {
                        onUploadProgress: (e) => {
                            setUploadProgress(Math.round((e.loaded * 100) / (e.total || 1)));
                        },
                    }).then(res => {
                        res.data.code === 200 ? afterUpload(id) : setOnce(false);
                    });
                } else {
                    setUploadProgress(100)
                    setPopOpen(true)
                    afterUpload(id)
                }
            }
            else {
                toast.error('저장중 오류가 발생했습니다.')
                setOnce(false)
            }
        })
    }

    const afterUpload = (id: string) => {
        setContainerFile([]);
        setFileArr([]);
        sendTeamRoom('quoteSimple', `📦 Pulse On Ship 간편 견적 요청 ${quoteInfo.step1.transportType === 'SEA' ? '⚓️' : '✈️'}\n
신청일시: ${getKoreaDateTime()}
유저: ${user.username}
회사이름: ${user.companyInfo.companyNameKr}
구분/운송: ${quoteInfo.step1.tradeType} / ${quoteInfo.step1.transportType}
HSCode: ${quoteInfo.step2.hsCode}
경로: ${countryCodeToEmoji(quoteInfo.step1.originCode.slice(0, 2))} ${quoteInfo.step1.originCode} | ${quoteInfo.step1.originAddress} > ${countryCodeToEmoji(quoteInfo.step1.destinationCode.slice(0, 2))} ${quoteInfo.step1.destinationCode} | ${quoteInfo.step1.destinationAddress}
`, id)
        window.sessionStorage.removeItem('simple');
    };

    return (
        <PageTemplate background='bg-[#F8F8FA]'>
            <Container className="flex flex-col gap-6 tablet:gap-4 mb-6 pt-21 tablet:pt-8">
                <First quoteInfo={quoteInfo} setQuoteInfo={setQuoteInfo} />
                <Second quoteInfo={quoteInfo} setQuoteInfo={setQuoteInfo} file={fileArr} />
            </Container>

            <Container>
                <div className='flex justify-center items-center gap-6 mb-30'>
                    <CustomButton
                        className='hover:!bg-transparent !border-primary !text-primary'
                        title='이전 페이지'
                        onClick={goBack}
                    />
                    <CustomButton
                        className='bg-primary'
                        title='작성 완료'
                        disabled={once}
                        onClick={saveQuote}
                    />
                </div>
            </Container>
            <QuoteDoneDialog
                isOpen={popOpen}
                type={quoteInfo?.step1?.transportType || 'SEA'}
                uploadProgress={uploadProgress}
            />
        </PageTemplate>
    )
}

export default SimpleConfrim